/**
 * PAN 掩码（对齐 web/admin/src/lib/format.ts maskPan 现实现）。
 * 数据红线：禁完整 PAN 默认展示（仅保留后四位）。
 */

/**
 * PAN 掩码：仅保留后四位，其余用 * 替换
 * @param pan 完整卡号或已部分掩码的字符串
 * @returns 形如 `**** **** **** 1234`
 */
export function maskPan(pan: string): string {
  if (!pan) return '—';
  // 已是掩码格式直接返回
  if (pan.includes('*')) return pan;
  const digits = pan.replace(/\D/g, '');
  if (digits.length < 4) return pan;
  const last4 = digits.slice(-4);
  return `**** **** **** ${last4}`;
}
